import {
  IconBoxDevice,
  IconBoxInfo,
  IconDateRange,
  IconFileEarmark,
  IconPigSaving,
} from "../../components/Icons/Icons";
import { formatCurrencyCOP } from "../../helpers/FormatNumber";
import "./AboutFund.css";

export const AboutFund = ({ data }) => {
  return (
    <div className="d-flex row w-100">
      {/* Descripción del fondo */}
      <div className="col-6 mb-3">
        <div className="d-flex align-items-baseline mb-2">
          <IconBoxDevice
            style={{ transform: "translate(0px, 5px)" }}
            colorIcon="#1b4ec1"
            height="20px"
            width="25px"
          />
          <div className="about-title">Descripción del fideicomiso</div>
        </div>
        <p class="text-left m-0">
          {data?.descripcion || "fideicomiso inmobiliario diseñado para generar rentabilidad a través de la inversión en proyectos de vivienda y oficinas en expansión. Su enfoque está en ubicaciones estratégicas de alta valorización."}
        </p>
      </div>

      {/* Detalle y Rentabilidad */}
      <div className="col-6 mb-3">
        <div className="d-flex align-items-baseline mb-2">
          <IconBoxInfo
            style={{ transform: "translate(0px, 5px)" }}
            colorIcon="#1b4ec1"
            height="20px"
            width="25px"
          />
          <div className="about-title">Detalle y Rentabilidad</div>
        </div>

        {/* Rentabilidad */}
        <div className="infoTec mb-2">
          <div className="infoTecBox d-flex align-items-start">
            <div className="icon-box me-2">
              <IconPigSaving style={{ transform: "translate(0px, 4px)" }} />
            </div>
            <div>
              <div className="infoTecBoxTitle">Rentabilidad último año</div>
              <div className="infoTecBoxText">{data?.tir_anual || 10}% E.A.</div>
            </div>
          </div>
        </div>

        {/* Gestor */}
        <div className="infoTec mb-2">
          <div className="infoTecBox d-flex align-items-start">
            <div className="icon-box me-2">
              <IconBoxDevice height="20px" width="20px" />
            </div>
            <div>
              <div className="infoTecBoxTitle">Gestor</div>
              <div className="infoTecBoxText">{data?.gestor || "N/A"}</div>
            </div>
          </div>
        </div>

        {/* Administrador */}
        <div className="infoTec mb-2">
          <div className="infoTecBox d-flex align-items-start">
            <div className="icon-box me-2">
              <IconBoxDevice height="20px" width="20px" />
            </div>
            <div>
              <div className="infoTecBoxTitle">Administrador</div>
              <div className="infoTecBoxText">{data?.administrador || "Acción Fiduciaria"}</div>
            </div>
          </div>
        </div>

        {/* Tipo de fondo */}
        <div className="infoTec mb-2">
          <div className="infoTecBox d-flex align-items-start">
            <div className="icon-box me-2">
              <IconBoxDevice height="20px" width="20px" />
            </div>
            <div>
              <div className="infoTecBoxTitle">Tipo de fondo</div>
              <div className="infoTecBoxText">{data?.tipo || "Inmobiliario"}</div>
            </div>
          </div>
        </div>

        {/* Categoría */}
        <div className="infoTec mb-2">
          <div className="infoTecBox d-flex align-items-start">
            <div className="icon-box me-2">
              <IconBoxDevice height="20px" width="20px" />
            </div>
            <div>
              <div className="infoTecBoxTitle">Categoría</div>
              <div className="infoTecBoxText">{data?.categoria || "N/A"}</div>
            </div>
          </div>
        </div>

        {/* Valor de la unidad */}
        <div className="infoTec mb-2">
          <div className="infoTecBox d-flex align-items-start">
            <div className="icon-box me-2">
              <IconBoxDevice height="20px" width="20px" />
            </div>
            <div>
              <div className="infoTecBoxTitle">Valor de la unidad</div>
              <div className="infoTecBoxText">{formatCurrencyCOP(data?.valor_unidad || 100000)}</div>
            </div>
          </div>
        </div>

        {/* Ficha técnica */}
        <div className="infoTec mb-2">
          <div className="infoTecBox d-flex align-items-start">
            <div className="icon-box me-2">
              <IconFileEarmark colorIcon="#B9DE2C" />
            </div>
            <div>
              <div className="infoTecBoxTitle">Ficha técnica</div>
              <div className="d-flex align-items-center">
                <i class="bi bi-paperclip"></i>
                {/* <Paperclip color="#5B6576" size={15} className="me-1" /> */}
                <div className="infoTecBoxText">ver documento</div>
              </div>
            </div>
          </div>
        </div>

        {/* Reglamento */}
        <div className="infoTec mb-2">
          <div className="infoTecBox d-flex align-items-start">
            <div className="icon-box me-2">
              <IconDateRange style={{ transform: "translate(0px, 4px)" }} />
            </div>
            <div>
              <div className="infoTecBoxTitle">Reglamento</div>
              <div className="d-flex align-items-center">
                <i class="bi bi-paperclip"></i>
                {/* <Paperclip color="#5B6576" size={15} className="me-1" /> */}
                <div className="infoTecBoxText">ver documento</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
